import { httpClient } from '@/infra/protocols/http';
import { IPodcastConfigurationDTO } from '@/modules/podcasts/dtos/podcast-configuration.dto';
import { IPodcastConfiguration } from '@/modules/podcasts/entities/podcast-configuration.entity';
import { PodcastConfigurationMapper } from '@/modules/podcasts/mappers/podcast-configuration.mapper';

export async function getPodcastConfiguration(
  params: GetPodcastConfigureService.Params,
): Promise<GetPodcastConfigureService.Response> {
  const response = await httpClient.get<IPodcastConfigurationDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/configuracoes`,
  );

  return PodcastConfigurationMapper.toDomain(response);
}

export namespace GetPodcastConfigureService {
  export interface Params {
    projectId: string;
    podcastId: string;
  }

  export type Response = IPodcastConfiguration;
}
